
// TODO: fix eslint
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

export class CountdownTimerComponent {
    private _currentContext: JQuery<HTMLElement> = null;

    // jquery-countdown docs: http://hilios.github.io/jQuery.countdown/documentation.html#event-object
    private readonly _yearsTemplate = "<span class='county'>%-Y year%!Y </span>";
    private readonly _monthsTemplate = "<span class='county'>%-m month%!m </span>";
    private readonly _weeksTemplate = "<span class='county'>%-W week%!W </span>";
    private readonly _daysTemplate = "<span class='county'>%-d day%!d </span>";
    private readonly _hoursTemplate = "<span class='county'>%-H hour%!H </span>";
    private readonly _minutesTemplate = "<span class='county'>%-M minute%!M </span>";
    private readonly _secondsTemplate = "<span class='county'>%-S second%!S</span>";

    private getTemplate(offset: jQueryCountdown.OffsetEvent): string  {
        if (offset.years > 0) {
            return `${this._yearsTemplate}${this._monthsTemplate}`;
        } else if (offset.months > 0) {
            return `${this._monthsTemplate}${this._weeksTemplate}`;
        } else if(offset.weeks > 0) {
            return `${this._weeksTemplate}${this._daysTemplate}`;
        } else if(offset.days > 0) {
            return `${this._daysTemplate}${this._hoursTemplate}${this._minutesTemplate}`;
        } else {
            return `${this._hoursTemplate}${this._minutesTemplate}${this._secondsTemplate}`;
        }
    }

    public init(context: JQuery<HTMLElement>, finalDateTime: string): void {
        this._currentContext = context || this._currentContext;

        this._currentContext.countdown(finalDateTime, (event: jQueryCountdown.Event) => {
            this._currentContext.html(event.strftime(this.getTemplate(event.offset)));
        });
    }

    public static init(context: JQuery<HTMLElement>, finalDateTime: string): CountdownTimerComponent {
        const component = new CountdownTimerComponent();
        component.init(context, finalDateTime);
        return component;
    }
}

